import script from "./PaperForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperForm.vue?vue&type=script&setup=true&lang=js"

import "./PaperForm.vue?vue&type=style&index=0&id=c9da1cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9da1cc8"]])

export default __exports__